import { parseApiData } from "go-core/api/parseApiData";
import { getSearchSelectPage, mapToBase } from "go-core/api/searchSelectService";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { restApi } from "../Security/api";
import { CoordinatesApi, GetCoordinatesApi, SearchSelectApi } from "./types";

class api {
	static async getResourceConfig(params?: Record<string, any>): Promise<{
		custom_fields: CustomFieldTemplateApi[];
	}> {
		return parseApiData(restApi.get(`resource_config`, { params }));
	}

	static async getCoordinates(params: GetCoordinatesApi): Promise<CoordinatesApi> {
		return parseApiData(restApi.get(`geolocation/coordinates`, { params }));
	}

	static async getOrganizationProductSearchSelect(
		search: string,
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<SearchSelectApi[]> {
		const f = mapToBase(search, params);
		const page = getSearchSelectPage(params);
		return parseApiData(
			restApi.get(`organizations/products/search_select?f=${f}&page=${page}`, {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}
}

export { api };
